import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=38c7520a&scoped=true&"
import script from "./LayoutAuth.vue?vue&type=script&lang=js&"
export * from "./LayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=38c7520a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7520a",
  null
  
)

export default component.exports